import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5ce8a794"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "header-section"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, " Login Page ", -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, " Reset password ", -1));
const _hoisted_4 = {
  class: "email-div"
};
const _hoisted_5 = {
  class: "btn-row"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_recovery_success = _resolveComponent("recovery-success");
  const _component_stroked_chevron_left_icon = _resolveComponent("stroked-chevron-left-icon");
  const _component_app_input_v2 = _resolveComponent("app-input-v2");
  const _component_app_button = _resolveComponent("app-button");
  const _component_app_form = _resolveComponent("app-form");
  const _component_the_wrapper_public_V2 = _resolveComponent("the-wrapper-public-V2");
  return $data.showSuccessMessage ? (_openBlock(), _createBlock(_component_recovery_success, {
    key: 0
  })) : (_openBlock(), _createBlock(_component_the_wrapper_public_V2, {
    key: 1
  }, {
    default: _withCtx(() => [_createVNode(_component_app_form, {
      onSubmit: $options.onSubmit,
      novalidate: ""
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = (...args) => $options.loginPage && $options.loginPage(...args)),
        class: "back-btn"
      }, [_createVNode(_component_stroked_chevron_left_icon), _hoisted_2]), _hoisted_3]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_app_input_v2, {
        modelValue: $data.form.email,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.form.email = $event),
        validateRule: "email",
        type: "email",
        label: "Email",
        placeholder: "Please enter your email",
        required: "",
        onSubmit: $options.onSubmit
      }, null, 8, ["modelValue", "onSubmit"])]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_app_button, {
        loading: $data.loading,
        type: "submit"
      }, {
        default: _withCtx(() => [_createTextVNode("Submit")]),
        _: 1
      }, 8, ["loading"])])]),
      _: 1
    }, 8, ["onSubmit"])]),
    _: 1
  }));
}